// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3--V1","question":"Question_question__2jiiy","description":"Question_description__345w9"};